module.exports = __webpack_public_path__ + "img/paper.d9b65427.png";